var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-3 py-3",attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',[_vm._v("List Service: Search")]),_c('v-card-text')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }